module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#tag",
      toString: function () {
        return this.url;
      }
    }